import { Koi } from '@ksyos/koi';

export const emailSchema = Koi.string().email({ tlds: false }).trim().max(255).options({ convert: true });
